export const FEATURE_NAME = '@zerops/zerops/feature/top-up-dialog/top-up-amount-form';
